import { render, staticRenderFns } from "./CkEditorCustom.vue?vue&type=template&id=51578972"
import script from "./CkEditorCustom.vue?vue&type=script&lang=js"
export * from "./CkEditorCustom.vue?vue&type=script&lang=js"
import style0 from "./CkEditorCustom.vue?vue&type=style&index=0&id=51578972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports